import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import RoundedModal from '../../../../molecules/RoundedModal'
import SydButton from '../../../../commonDesign/Button'
import SydModalActions from '../../../../commonDesign/SydModal/SydModalActions'
import { useRemoveComponentBlueprintVersion } from '../../../../../api/denali'
import { decipherError } from '../../../../../utils/decipherError'

const DeleteVersionDialog = React.forwardRef(function DeleteVersionDialog ({ blueprint, onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, version: null })
  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState(null)
  const { mutateAsync: removeVersion } = useRemoveComponentBlueprintVersion()

  const close = useCallback(() => {
    setDialogState({ open: false, version: null })
    setError(null)
  }, [])

  useImperativeHandle(ref, () => ({
    open: (version) => setDialogState({ open: true, version })
  }), [])

  const handleConfirm = useCallback(async () => {
    try {
      setError(null)
      setProcessing(true)

      await removeVersion({
        blueprintId: blueprint.blueprintId,
        definitionVersionId: dialogState.version.definitionVersionId
      })

      close()
      onComplete()
    } catch (err) {
      setError(decipherError(err))
    } finally {
      setProcessing(false)
    }
  }, [removeVersion, blueprint, dialogState, close, onComplete])

  return (
    <RoundedModal
      title='Delete Version'
      open={dialogState.open}
      onClose={close}
      size='medium'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <p>Are you sure you want to delete version <strong>{dialogState.version?.definitionVersionId}</strong>?</p>
              <p>This action cannot be undone.</p>
            </Grid>
            <Grid item xs={12}>
              <SydModalActions>
                {error ? <div className='__error'>{error}</div> : null}
                <SydButton disabled={processing} variant='ghost' size='md' onClick={close}>
                  Cancel
                </SydButton>
                <SydButton processing={processing} variant='primary' priority='warning' icon='delete' size='md' onClick={handleConfirm}>
                  Delete
                </SydButton>
              </SydModalActions>
            </Grid>
          </Grid>
        ) : null}
      </div>
    </RoundedModal>
  )
})

DeleteVersionDialog.propTypes = {
  blueprint: PropTypes.object.isRequired,
  onComplete: PropTypes.func.isRequired
}

export default DeleteVersionDialog
